module.exports = __webpack_public_path__ + "img/databases.b3112ce5.png";